import React from 'react'
import { Typography } from '@mui/material'
import { FormikHandlers } from 'formik'
import ErrorComponent from 'src/assets/error'
import Checkbox from '@mui/material/Checkbox'

import {
    ContentAcceptTerms,
    ContainerAcceptTerms,
    ErrorImgBox,
    ErrorText,
    ContentErrorDataMessage,
} from './styles'
import Deactivated from 'src/assets/form/Deactivated'
import Active from 'src/assets/form/Active'

interface ITermsAndConditionsProps {
    values: boolean
    errors: string | undefined
    touched: boolean | undefined
    onChange: FormikHandlers['handleChange']
    onBlur: FormikHandlers['handleChange'] | undefined
    Content: string
    data?: string | undefined
}

export const TermsAndConditions = ({
    values,
    errors,
    touched,
    onChange,
    onBlur,
    Content,
    data,
}: ITermsAndConditionsProps) => {
    return (
        <ContainerAcceptTerms>
            <ContentAcceptTerms>
                <Checkbox
                    className={'checkbox'}
                    color="secondary"
                    value={values}
                    checked={values}
                    onBlur={onBlur ? onBlur(data) : undefined}
                    icon={<Deactivated />}
                    checkedIcon={<Active />}
                    onChange={onChange(data)}
                />
                <Typography
                    variant="h1"
                    fontSize={'small'}
                    fontWeight={500}
                    color="#828282"
                >
                    {Content}
                </Typography>
            </ContentAcceptTerms>
            {touched && errors ? (
                <ContentErrorDataMessage
                    marginLeft={'xxsmall'}
                    paddingTop={'small'}
                >
                    <ErrorImgBox>
                        <ErrorComponent />
                    </ErrorImgBox>
                    <ErrorText
                        variant={'h4'}
                        fontSize={'small'}
                        fontWeight={600}
                    >
                        {errors}
                    </ErrorText>
                </ContentErrorDataMessage>
            ) : null}
        </ContainerAcceptTerms>
    )
}
